module.exports = __webpack_public_path__ + "static/media/status_2.fcb4bc74.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/hgcPayment/images/status_2.png
// module id = 629
// module chunks = 0